module.exports = __webpack_public_path__ + "static/media/img_18.634ed653.png";